/**
 * @prettier
 */

import React from 'react';
import { Banner } from '@zola/zola-ui';
import { UnitedStates } from 'components/common/form/CountryCodes';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import SamplePreview from '../SamplePreview/SamplePreview';
import Layout from '../Layout/Layout';
import { STEPS } from '../constants/steps';

const stateFilter = option => !['AA', 'AE', 'AP'].includes(option.value);

const StateDropdownOptions = UnitedStates.filter(stateFilter).map(option => ({
  label: option.title,
  value: option.value,
}));

const ShippingDetailsForm = ({
  form,
  goToStep,
  errors,
  step,
  isGuest,
  colors,
  sampleNotCustomizable,
  breadcrumbSteps,
  template,
  updateForm,
  skuData,
  cardSuiteDetails,
  isMagnet,
}) => {
  const { address, apt, city, state, zipCode } = form.shipping;

  const setField = key => event => updateForm({ shipping: { [key]: event.target.value } });

  const setState = option => updateForm({ shipping: { state: option } });

  return (
    <Layout.Form
      onSubmit={() => goToStep(isGuest ? STEPS.ACCOUNT_DETAILS_FORM : STEPS.SAMPLE_PREVIEW)}
    >
      <Layout.Box>
        <Layout.Row>
          <Layout.PreviewBox>
            <SamplePreview
              hideColorPicker={sampleNotCustomizable}
              colors={colors}
              template={template}
              form={form}
              updateForm={updateForm}
              sampleNotCustomizable={sampleNotCustomizable}
              skuData={skuData}
              cardSuiteDetails={cardSuiteDetails}
              isMagnet={isMagnet}
            />
          </Layout.PreviewBox>
          <Layout.Col>
            <BreadCrumbs.Text step={step} breadcrumbSteps={breadcrumbSteps} />
            <Layout.Header>Where should we send your sample?</Layout.Header>
            {errors && errors.shipping && <Banner type="error">{errors.shipping}</Banner>}
            <Layout.InputGroup>
              <Layout.Field
                required
                type="text"
                label="Street Address"
                input={{ name: 'address', value: address || '', onChange: setField('address') }}
              />
              <Layout.Spacer />
              <Layout.Field
                small
                type="text"
                label="Apt/Floor"
                input={{ name: 'apt', value: apt || '', onChange: setField('apt') }}
              />
            </Layout.InputGroup>
            <Layout.Field
              required
              type="text"
              label="City"
              input={{ name: 'city', value: city || '', onChange: setField('city') }}
            />
            <Layout.InputGroup>
              <Layout.Dropdown
                required
                name="state"
                label="State"
                selected={state}
                options={StateDropdownOptions}
                onSelect={setState}
              />
              <Layout.Spacer />
              <Layout.Field
                required
                small
                type="text"
                label="Zip Code"
                input={{ name: 'zipCode', value: zipCode || '', onChange: setField('zipCode') }}
              />
            </Layout.InputGroup>
            <Layout.FormButtons
              backLabel="Back"
              nextLabel={isGuest ? 'Next' : 'Preview Sample'}
              nextDisabled={!address || !city || !state || !zipCode}
              onBack={() => goToStep(STEPS.WEDDING_DETAILS_FORM)}
            />
          </Layout.Col>
        </Layout.Row>
        <BreadCrumbs.Dots step={step} breadcrumbSteps={breadcrumbSteps} />
      </Layout.Box>
    </Layout.Form>
  );
};

export default ShippingDetailsForm;



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SingleSampleFlowSteps/ShippingDetailsForm.jsx